import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-8" }
const _hoisted_2 = { class: "text-center mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-800 mb-4" }
const _hoisted_4 = { class: "space-y-6" }
const _hoisted_5 = { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-3" }
const _hoisted_6 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_7 = { class: "bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium" }
const _hoisted_8 = { class: "text-lg font-medium text-blue-600 mb-2" }
const _hoisted_9 = { class: "text-gray-600 mb-3" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "font-medium text-gray-800 mb-2" }
const _hoisted_12 = { class: "list-disc list-inside text-gray-600 space-y-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('education.title')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.education, (edu) => {
        return (_openBlock(), _createElementBlock("div", {
          key: edu.school,
          class: "bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-6 border-l-4 border-blue-500"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(edu.degree), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(edu.year), 1)
          ]),
          _createElementVNode("h4", _hoisted_8, _toDisplayString(edu.school), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(edu.description), 1),
          (edu.achievements && edu.achievements.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t('education.achievements')), 1),
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(edu.achievements, (achievement) => {
                    return (_openBlock(), _createElementBlock("li", { key: achievement }, _toDisplayString(achievement), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}